/**
 * @desc 查询生料生产月计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthRawMealResponse>> {
  return defHttp.post({
    url: '/web/plan/month/queryPlanRawMeal',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthRawMealResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/month/queryPlanRawMeal',
    data,
  });
}
